<ng-container>
    <div fxLayout.gt-xs="row"
         fxLayout="column"
         fxLayoutAlign="space-between center"
         fxLayoutGap="15px"
         class="box syn---flat"
         [class]="{ 'no-margin-top': noMarginTop }"
         [ngStyle]="{
             'background-color': backgroundColor,
             'border': hasBorder ? '1px solid ' + textColor : undefined,
             'border-radius': borderRadius + 'px'
        }">
        <mat-icon *ngIf="leftIcon"
                  class="icon"
                  [ngStyle]="{'color': iconColor}" [svgIcon]="leftIcon"></mat-icon>
        <div *ngIf="letter"
             class="letter_container">
            <div class="letter"
                 [ngStyle]="{'background-color': backgroundColor, 'color': textColor}">
                {{ letter }}
            </div>
        </div>
        <div class="mainText"
             fxFlex
             [ngStyle]="{'color': textColor, 'text-align': textAlign}">
            <ng-content></ng-content>
        </div>
        <img *ngIf="image"
             class="image"
             [src]="image"
             fxFlex.gt-xs="20%"
             fxFlex="100px"
             (click)="fullscreen()" />
        <mat-icon *ngIf="rightIcon"
                  class="icon"
                  [ngStyle]="{'color': textColor}" [svgIcon]="rightIcon"></mat-icon>
    </div>
    <p class="subText"
       *ngIf="subText">
        {{ subText }}
    </p>
</ng-container>
